/**
 * Minimal `$localize` shim for Angular MFEs that use i18n.
 *
 * Angular's `@angular/localize/init` defines `globalThis.$localize` as a tagged
 * template function. When the host shell is React, this polyfill is missing.
 * MFEs like `rsm` that compile with i18n will throw `ReferenceError: $localize
 * is not defined` at bootstrap.
 *
 * This shim provides an identity implementation (no translation, English
 * pass-through) so Angular MFEs can mount without crashing. If real i18n is
 * needed, swap this for the full `@angular/localize/init` UMD bundle.
 */

declare global {
  var $localize: ((messageParts: TemplateStringsArray, ...expressions: unknown[]) => string) & {
    translate?: unknown;
    locale?: string;
  };
}

export function ensureLocalize(): void {
  if (typeof globalThis.$localize === 'function') return;

  globalThis.$localize = Object.assign(
    function $localize(messageParts: TemplateStringsArray, ...expressions: unknown[]): string {
      let result = messageParts[0];
      for (let i = 0; i < expressions.length; i++) {
        result += String(expressions[i]) + messageParts[i + 1];
      }
      return result;
    },
    { locale: 'en-US' },
  );
}
